<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>

      <v-container fluid>
        <br />
        <template v-if="tipoConsulta != 3">
          <template v-if="idCuadrilla == 0">
            <span class="d-flex justify-center">Cuadrilla: Sin Asignar</span>
          </template>
          <template v-if="idCuadrilla != 0">
            <span class="d-flex justify-center"
              >Cuadrilla: {{ cuadrillaIntegrantes }}</span
            >
          </template>
        </template>
        <br />
        <br />
        <br />
        <template v-if="tipoConsulta == 3">
          <v-autocomplete
            v-model="cuadrillaSeleccionada"
            :items="cuadrillas"
            item-value="idCuadrilla"
            item-text="cuadrilla"
            label="Cuadrillas"
            height="20"
            return-object
            @change="cambioMaterial(props.item)"
            no-data-text="No hay coincidencias"
            clearable
          ></v-autocomplete>
        </template>

        <template v-if="tipoConsulta == 1">
          <v-data-table
            :headers="headers"
            :items="listaMaterialesCajon"
            item-key="idCajon"
            sort-by="idCajon"
            :search="buscar"
            :header-props="headerProps"
            :footer-props="footerProps"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
          </v-data-table>

          <v-data-table
            :headers="headersBobina"
            :items="listaBobinasCajon"
            item-key="idCajon"
            sort-by="idCajon"
            :search="buscar"
            :header-props="headerProps"
            :footer-props="footerProps"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
            <template v-slot:[`item.cantidadActual`]="{ item }">
              {{
                getCantidadDisponible(item.secInicioActual, item.secFinActual)
              }}
            </template>
          </v-data-table>

          <v-data-table
            :headers="headersMedidores"
            :items="listaMedidores"
            item-key="idCajon"
            sort-by="idCajon"
            :search="buscar"
            :header-props="headerProps"
            :footer-props="footerProps"
            no-data-text="No se encontraron registros"
            no-results-text="No se encontraron registros en la búsqueda"
          >
          </v-data-table>
        </template>
        <template v-if="tipoConsulta == 2">
          <v-data-table
            :headers="cabeceras"
            :items="listaMaterialesCajon"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Materiales Modificacion</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Material</span>
                </v-tooltip>

                <!-- <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="agregarMaterialALaLista"
                >
                  Agregar Material
                </v-btn> -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialConfirmar(datos)"
                        >Eliminar Material</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.nombre`]="props">
              <v-autocomplete
                v-model="props.item.idMaterial"
                :items="listaMateriales"
                item-value="idMaterial"
                :item-text="(item) => `${item.idMaterial} - ${item.nombre}`"
                label="Materiales"
                height="20"
                return-object
                @change="cambioMaterial(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.cantidadActualOT`]="props">
              <v-text-field
                v-model="props.item.cantidadActualOT"
                label="Cantidad Disponible OT"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.cantidadDisponible`]="props">
              <v-text-field
                v-model="props.item.cantidadDisponible"
                label="Cantidad Actual"
                type="number"
                @click="eventoOnClick(props.item)"
                readonly
              ></v-text-field>
            </template>

            <!-- <template v-slot:[`item.cantidadIngresar`]="props">
              <v-text-field
                v-model="props.item.cantidadIngresar"
                label="Cantidad a Ingresar"
                type="number"
              ></v-text-field>
            </template> -->

            <template v-slot:[`item.cantidadIngresar`]="props">
              <template
                v-if="
                  (props.item.idMaterial &&
                    props.item.idMaterial.nombre &&
                    props.item.idMaterial.nombre.startsWith('Medidor') &&
                    (props.item.idMaterial.nombre
                      .toLowerCase()
                      .includes('tri') ||
                      props.item.idMaterial.nombre
                        .toLowerCase()
                        .includes('mono'))) ||
                  (props.item.nombre.startsWith('Medidor') &&
                    (props.item.nombre.toLowerCase().includes('tri') ||
                      props.item.nombre.toLowerCase().includes('mono')))
                "
              >
                <!-- <v-autocomplete
                  v-model="props.item.medidores"
                  :items="props.item.listaMedidores"
                  item-value="idMedidor"
                  item-text="nombre"
                  label="Medidores"
                  height="20"
                  return-object
                  no-data-text="No hay coincidencias"
                  clearable
                  multiple
                  chips
                ></v-autocomplete> -->
                <v-autocomplete
                  v-model="props.item.medidores"
                  :items="getMedidoresOrdenados(props.item)"
                  item-value="idMedidor"
                  item-text="nombre"
                  label="Seleccione los Medidores"
                  height="20"
                  return-object
                  no-data-text="No hay coincidencias"
                  clearable
                  multiple
                  chips
                  :loading="props.item.cargandoMedidores"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      {{ item.nombre }}
                    </v-chip>
                    <span v-if="index === 3">
                      +{{ props.item.medidores.length - 3 }} más
                    </span>
                  </template>
                </v-autocomplete>
              </template>
              <template v-else>
                <v-text-field
                  v-model="props.item.cantidadIngresar"
                  label="Cantidad"
                  clearable
                  type="number"
                ></v-text-field>
              </template>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterial(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Material</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-data-table
            :headers="cabecerasBobinas"
            :items="tablaMaterialesBobinasCajonModificacion"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Bobinas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialBobinaALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Bobina</span>
                </v-tooltip>

                <!-- <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="agregarMaterialALaLista"
                >
                  Agregar Material
                </v-btn> -->
                <v-dialog v-model="dialogDeleteBobina" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar esta Bobina de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogDeleteBobina = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialBobinaConfirmar(datos)"
                        >Eliminar Bobina</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-autocomplete
                v-model="props.item.idMaterial"
                :items="listaMaterialesCable"
                item-value="idMaterial"
                item-text="nombre"
                label="Materiales"
                height="20"
                return-object
                @change="cambioMaterialCable(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.bobina`]="props">
              <v-autocomplete
                v-model="props.item.idBobinaC"
                :items="listaBobinas"
                item-value="idBobinaC"
                item-text="idBobinaC"
                label="Bobina"
                height="20"
                return-object
                @change="cambioMaterialCable(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template>

            <template v-slot:[`item.secInicio`]="props">
              <v-text-field
                v-model="props.item.cantidad"
                label="Cantidad"
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.cantidad`]="props">
              <v-text-field
                v-model="props.item.cantidad"
                label="Cantidad"
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.cantidad`]="props">
              <v-text-field
                v-model="props.item.cantidad"
                label="Cantidad"
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterialBobina(item)"
                    class="ml-2"
                    v-if="
                      saldoMenor(item.cantidadSaldo, item.cantidadInicial) ==
                      false
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Bobina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </template>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="tipoConsulta == 3">
          <v-btn color="blue darken-1" text @click="asignarCajon">
            Asignar Cuadrilla
          </v-btn>
        </template>
        <template v-if="tipoConsulta == 2">
          <v-btn color="blue darken-1" text @click="armarCajon">
            Guardar
          </v-btn>
        </template>
        <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
      </v-card-actions>
    </v-card>

    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
  </v-dialog>
</template>

<script>
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";

export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      dialogDeleteBobina: false,
      listaMedidores: [],
      listaBobinasCajon: [],
      idCuadrilla: "",
      cuadrillaSeleccionada: "",
      idMaterialEliminado: "",
      cantidadMaterialEliminado: "",
      listaMaterialesEliminados: [],
      listaMaterialesOriginales: [],
      tipoConsulta: "",
      dialogDelete: false,
      idOT: "",
      contratistaSeleccion: "",
      dialog: false,
      colorDialogTitle: "",
      formTitle: "",
      idCajon: "",
      cuadrillaIntegrantes: "",
      listaMaterialesCajon: [],
      buscar: "",
      editedItem: {
        //cantidad: 0,
        //medida: "",
        //MaterialSeleccionado: null,
        //MaterialSeleccionadoNombre: null,
        //MaterialSeleccionadoId: null,
        nombre: "",
        cantidadActualOT: null,
        cantidadDisponible: 0,
        cantidadIngresar: null,
      },
      tablaMaterialesBobinasCajonModificacion: [],
      cabecerasBobinas: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        {
          text: "Bobina",
          value: "Bobina",
          class: "black white--text",
        },
        {
          text: "Cantidad Disponible",
          value: "cantidadDisponible",
          class: "black white--text",
        },
        {
          text: "Secuencia Inicio Disponible",
          value: "secInicio",
          class: "black white--text",
        },
        {
          text: "Secuencia Fin Disponible",
          value: "secFin",
          class: "black white--text",
        },
        {
          text: "Secuencia Inicio",
          value: "secInicioIngresar",
          class: "black white--text",
        },
        {
          text: "Secuencia Fin",
          value: "secFinIngresar",
          class: "black white--text",
        },

        {
          text: "Cantidad de Metros",
          value: "cantidadTotalM",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "black white--text",
        },
      ],
      tablaMaterialesCajonModificacion: [],
      headers: [
        {
          text: "Descripcion",
          value: "nombre",
          class: "black white--text",
        },
        {
          text: "Cantidad Total Otorgada al Cajon",
          value: "cantidadInicial",
          class: "black white--text",
        },
        {
          text: "Cantidad Saldo",
          value: "cantidadDisponible",
          class: "black white--text",
        },
      ],
      headersBobina: [
        {
          text: "Descripcion",
          value: "descripcionCable",
          class: "black white--text",
        },
        { text: "Bobina", value: "idBobinaC", class: "black white--text" },
        {
          text: "Secuencia Inicio Actual",
          value: "secInicioActual",
          class: "black white--text",
        },
        {
          text: "Secuencia Final Actual",
          value: "secFinActual",
          class: "black white--text",
        },
        {
          text: "Cantidad Total Otorgada al Cajón",
          value: "cantidadTotal",
          class: "black white--text",
        },
        {
          text: "Cantidad Actual Disponible",
          value: "cantidadActual",
          class: "black white--text",
        },
      ],
      headersMedidores: [
        { text: "Matricula", value: "idMaterial", class: "black white--text" },
        {
          text: "Codigo Medidor",
          value: "idMedidor",
          class: "black white--text",
        },
        {
          text: "Descripcion",
          value: "descripcionMedidor",
          class: "black white--text",
        },
      ],
      cabeceras: [
        {
          text: "Material",
          value: "nombre",
          class: "black white--text",
        },
        {
          text: "Cantidad Disponible OT",
          value: "cantidadActualOT",
          class: "black white--text",
        },
        //{ text: "Cantidad Actual", value: "CantidadDisponible" },
        {
          text: "Cantidad Actual en el Cajon",
          value: "cantidadDisponible",
          class: "black white--text",
        },
        {
          text: "Cantidad Agregar",
          value: "cantidadIngresar",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          class: "black white--text",
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },
      other: [1, 20, 344, 44444],
      footerProps: {
        itemsPerPageText: "Registros por página",
        pageText: "{0}-{1} de {2}",
        itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
      },
    };
  },

  mounted() {
    //console.log("Ingreso en modalCajones");
    //this.getDetallesCajon();
    this.getListarMaterialesContratista();
  },

  methods: {
    eventoOnClick(item) {
      console.log("Hago click en cantidad actual");
      console.log(item);
    },

    // async getMedidoresOrdenados(item) {
    //   console.log("LOs medidores para ordernar son:");
    //   console.log(item.medidores);
    //   if (!item) return [];

    //   if (item.medidores) {
    //     const seleccionados = item.medidores;
    //     const todos = item.listaMedidores;

    //     const idsSeleccionados = new Set(seleccionados.map((m) => m.idMedidor));

    //     const seleccionadosPrimero = todos.filter((m) =>
    //       idsSeleccionados.has(m.idMedidor)
    //     );
    //     const restantes = todos.filter(
    //       (m) => !idsSeleccionados.has(m.idMedidor)
    //     );

    //     console.log("Los primeros campos elegidos son: ");
    //     console.log(seleccionadosPrimero);
    //     console.log("Los ultimos elegidos son: ");
    //     console.log(restantes);

    //     return [...seleccionadosPrimero, ...restantes];
    //   } else {
    //     return item.listaMedidores;
    //   }
    // },

    getMedidoresOrdenados(item) {
      console.log("LOs medidores para ordernar son:");
      console.log(item.medidores);
      console.log(item.listaMedidores);

      item.listaMedidores = item.listaMedidores.map((id) => ({
        idMedidor: id,
        nombre: id.toString(),
      }));

      if (!item || !Array.isArray(item.listaMedidores)) return [];

      const seleccionados = Array.isArray(item.medidores) ? item.medidores : [];
      const todos = item.listaMedidores.filter(
        (m) => m.idMedidor !== undefined && m.idMedidor !== null
      );

      // Convertir idMedidor a string
      const idsSeleccionados = new Set(
        seleccionados.map((m) => String(m.idMedidor))
      );

      // Buscar objetos completos desde listaMedidores
      const seleccionadosPrimero = todos.filter((m) =>
        idsSeleccionados.has(String(m.idMedidor))
      );

      const restantes = todos.filter(
        (m) => !idsSeleccionados.has(String(m.idMedidor))
      );

      return [...seleccionadosPrimero, ...restantes];
    },

    // getMedidoresOrdenados(item) {
    //   console.log("LOs medidores para ordernar son:");
    //   console.log(item.medidores);
    //   console.log(item.listaMedidores);
    //   if (!item) return [];

    //   if (item.medidores) {
    //     const seleccionados = item.medidores;
    //     const todos = item.listaMedidores;

    //     console.log("Dentro dle if:");
    //     console.log(seleccionados);
    //     console.log(todos);

    //     const todosValidos = todos.filter(
    //       (m) => m.idMedidor !== undefined && m.idMedidor !== null
    //     );

    //     // Convertir todos los ids a string para evitar problemas de tipo
    //     const idsSeleccionados = new Set(
    //       seleccionados.map((m) => String(m.idMedidor))
    //     );

    //     const seleccionadosPrimero = todosValidos.filter((m) =>
    //       idsSeleccionados.has(String(m.idMedidor))
    //     );
    //     const restantes = todosValidos.filter(
    //       (m) => !idsSeleccionados.has(String(m.idMedidor))
    //     );

    //     console.log("Tipos en medidores seleccionados:");
    //     seleccionados.forEach((m) =>
    //       console.log(typeof m.idMedidor, m.idMedidor)
    //     );

    //     console.log("Tipos en listaMedidores:");
    //     todos.forEach((m) => console.log(typeof m.idMedidor, m.idMedidor));

    //     console.log("Los primeros campos elegidos son: ");
    //     console.log(seleccionadosPrimero);
    //     console.log("Los ultimos elegidos son: ");
    //     console.log(restantes);

    //     return [...seleccionadosPrimero, ...restantes];
    //   } else {
    //     return item.listaMedidores;
    //   }
    // },

    agregarMaterialBobinaALaLista(material) {
      console.log("La cantidad de materiales es");
      console.log(this.tablaMateriales.length);
      console.log("Ingreso en agregar bobina a la lista");
      if (this.editedIndex > -1) {
        Object.assign(
          this.tablaMaterialesBobinas[this.editedIndex],
          this.editedItem
        );
      } else {
        console.log("El ultimo registro es: ");
        console.log(
          this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
        );
        if (this.tablaMaterialesBobinas.length == 0) {
          console.log("No hay registros en la tabla");
          this.vaciarEditedItem();
          this.tablaMaterialesBobinas.push(this.editedItem);
          // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoNombre = material.nombre;
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoId = material.idMaterial;
        } else {
          console.log("Ya hay registros");
          if (
            this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
              .MaterialSeleccionadoNombre != null
          ) {
            console.log("Ha ingresado material en la tabla");
            if (
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secInicioIngresar != null ||
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secFinIngresar != null
            ) {
              console.log("Ha una cantidad distinta de null");
              if (
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secInicioIngresar != 0 ||
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secFinIngresar != 0
              ) {
                console.log("Ha una cantidad distinta de 0");
                this.vaciarEditedItem();
                this.tablaMaterialesBobinas.push(this.editedItem);
                // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoNombre = material.nombre;
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoId = material.idMaterial;
              }
            }
          }
        }
      }
      console.log("Estoy hay en la tabla de bobinas: ");
      console.log(this.tablaMaterialesBobinas);
    },

    async getListarCuadrillaByContratista() {
      console.log("getListarCuadrillaByContratista");
      const idUsuario = this.$store.getters.usuario.user_id;
      const idEmpresa = this.$store.getters.usuario.idContratista;

      this.url = `${this.$store.getters.urlBase}Cuadrilla?idUsuario=${idUsuario}&idEmpresa=${idEmpresa}`;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async asignarCajon() {
      console.log("la cuadrilla seleccionada es");
      console.log(this.cuadrillaSeleccionada.cuadrilla);
      if (this.cuadrillaSeleccionada == "") {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha seleccionado una cuadrilla para asignarle el cajon",
          1,
          "red",
          "Aviso"
        );
        return;
      }
      console.log("El cajon seleccionado es: ");
      console.log(this.idCajonSeleccionado);
    },

    asignarCajonOpen(cajonSeleccionado) {
      this.formTitle = "Seleccione una cuadrilla";
      this.tipoConsulta = 3;
      this.idCajonSeleccionado = cajonSeleccionado.idCajon;
      console.log("El id del cajon seleccionado es ");
      console.log(this.idCajonSeleccionado);
      this.colorDialogTitle = "orange";
      this.getListarCuadrillaByContratista();
      // console.log("Los datos de la cuadrilla enviada son: " + datos);
      // console.log(datos);
      this.dialog = true;

      // console.log("El valor de habilitar");
      // console.log(this.habilitarSelect);
    },

    saldoMenor(cantidadSaldo, cantidadDisponible) {
      console.log("Ingreso en saldo menor");
      console.log(cantidadSaldo);
      console.log(cantidadDisponible);
      if (cantidadSaldo < cantidadDisponible) {
        console.log("Ingreso en el true");
        return true;
      } else {
        return false;
      }
    },

    async armarCajon() {
      var sobreStock = 0;

      this.tablaMaterialesCajonModificacion.forEach((material) => {
        if (material.cantidadDisponible < material.cantidad) {
          console.log("Hay un material que excede el limite");
          sobreStock = 1;
          return;
        }
      });

      if (sobreStock == 1) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Hay un/os material/es que excede el limite ",
          1,
          "red",
          "Aviso"
        );
        //this.mensajeError();
        return;
      }

      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Esta por modificar los datos del Cajon N° " +
          this.idCajon +
          ", desea continuar?",
        2,
        "green",
        "Confirmacion"
      );

      this.url = this.$store.state.urlBase + "Cajon/modificarCajon";
      //this.url = this.$store.state.urlBas/api;

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMaterialesCajonModificacion);

      let datosMaterial = [];

      this.tablaMaterialesCajonModificacion.forEach((material) => {
        console.log("El id del material es");
        console.log(material.MaterialSeleccionadoNombre.idMaterial);
        console.log("La cantidad del material es:");
        console.log(material.cantidad);
        datosMaterial.push({
          idMaterial: material.MaterialSeleccionadoNombre.idMaterial.toString(),
          cantidad: material.cantidad,
        });
      });

      var datos = {
        listaMateriales: datosMaterial,
        idCajon: this.idCajon,
      };

      console.log("Los datos son");

      console.log(datos);

      this.dialog = false;

      this.$emit("recargarListado");
    },

    async getListarMaterialesContratista() {
      console.log("Ingresos a cargar los materiales");

      this.url =
        `${this.$store.state.urlBase}Material/recuperarMaterialesContratista` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material es:");
        console.log(respuesta.data);
        this.listaMateriales = respuesta.data;
        this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
      this.getDetallesCuadrilla();
      this.getDetallesCajon();
    },

    async getDetallesCajon() {
      console.log("Ingreso en los detalles del cajon");
      this.url =
        this.$store.getters.urlBase +
        "Cajon/recuperarCajonMateriales?idCajon=" +
        this.idCajon +
        "&idContratista=" +
        this.$store.getters.usuario.idContratista;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaMaterialesCajon = response.data;
          console.log(this.listaMaterialesCajon);
          return response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.tablaMaterialesCajonModificacion = respuesta;
      this.listaMaterialesCajon = respuesta;
      this.loadingButton = false;
      respuesta.forEach((material) => {
        this.listaMaterialesOriginales.push({
          idMaterial: material.idMaterial,
          cantidad: material.cantidadDisponible,
        });
      });

      // console.log("Lo que hay en la tabla Materiales para la modificacion es");
      // console.log(this.tablaMaterialesCajonModificacion);

      console.log("Los materiales originales son: ");
      console.log(this.listaMaterialesOriginales);

      await this.getDetallesCuadrilla();
      await this.getDetallesCajonBobinas();
      await this.getDetallesCajonMedidores();
    },

    async getDetallesCajonMedidores() {
      this.url =
        this.$store.getters.urlBase +
        "Cajon/recuperarCajonMedidores?idCajon=" +
        this.idCajon +
        "&idContratista=" +
        this.$store.getters.usuario.idContratista;
      console.log("Ingreso en recuperar Detalles medidores");
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          //console.log("Respuesta de recuperar materiales medidores cajon");
          //console.log(response.data);
          this.listaMedidores = response.data;
          //console.log(this.listaMedidores);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          //console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      console.log("El tipo de consulta es:");
      console.log(this.tipoConsulta);

      this.listaMedidores = respuesta;

      if (this.tipoConsulta == 2) {
        console.log("La lista de medidores es :");
        console.log(this.listaMedidores);
        console.log("La lista de materiales es :");
        console.log(this.listaMaterialesCajon);

        const medidoresPorMaterial = {};

        this.listaMedidores.forEach((medidor) => {
          const idMaterial = medidor.idMaterial;

          if (!medidoresPorMaterial[idMaterial]) {
            medidoresPorMaterial[idMaterial] = [];
          }

          medidoresPorMaterial[idMaterial].push({
            idMedidor: medidor.idMedidor,
            nombre: medidor.idMedidor.toString(), // como pediste, nombre es igual al idMedidor
          });
        });

        for (const medidor of this.listaMedidores) {
          let medidorRepetido = this.listaMaterialesCajon.some(
            (material) => material.idMaterial == medidor.idMaterial
          );

          if (!medidorRepetido) {
            const listaMedidores =
              await this.recuperarMedidoresXIdContratistaXMatricula(
                this.$store.getters.usuario.idContratista,
                medidor.idMaterial
              );

            this.listaMaterialesCajon.push({
              cantidad: 0,
              cantidadActual: null,
              cantidadActualCajon: null,
              cantidadActualOT: 0,
              cantidadCajon: 0,
              cantidadDisponible: 0,
              cantidadInicial: 0,
              cantidadInicialOT: 0,
              cantidadOT: 0,
              cantidadSaldo: 0,
              cantidadUtilizada: 0,
              estado: 0,
              fecha: null,
              idCajon: 0,
              idMaterial: String(medidor.idMaterial),
              idOT: medidor.idOT,
              idRemito: 0,
              nombre: medidor.descripcionMedidor,
              listaMedidores: listaMedidores,
              medidores: medidoresPorMaterial[String(medidor.idMaterial)],
            });
          }
        }

        console.log("La lista de materiales es despues de agregar medidores:");
        console.log(this.listaMaterialesCajon);
      }
    },

    // async recuperarMedidoresXIdContratistaXMatricula(
    //   idContratista,
    //   idMaterial
    // ) {
    //   var respuesta;

    //   this.url =
    //     `${this.$store.state.urlBase}Material/recuperarMedidoresXIdContratistaXMatricula` +
    //     `?idContratista=${this.$store.getters.usuario.idContratista}&matricula=${idMaterial}`;

    //   const config = {
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
    //     },
    //   };

    //   respuesta = await axios
    //     .get(this.url, config)
    //     .then((response) => response.data);

    //   var listaMedidores = respuesta;

    //   console.log("El resultado de la respuesta de recuperar medidores es:");
    //   console.log(listaMedidores);
    //   return listaMedidores;
    // },

    async getDetallesCajonBobinas() {
      //console.log("Ingreso en los detalles bobinas del cajon");
      this.url =
        this.$store.getters.urlBase +
        "Cajon/recuperarCajonBobinas?idCajon=" +
        this.idCajon;

      this.listaBobinasCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      //console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          //console.log("Respuesta de recuperar materiales bobinas cajon");
          //c//onsole.log(response.data);
          this.listaBobinasCajon = response.data;
          //console.log(this.listaBobinasCajon);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          //console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.tablaMaterialesCajonModificacion = respuesta;
      this.listaBobinasCajon = respuesta;
      this.tablaMaterialesBobinasCajonModificacion = respuesta;
      console.log("La tabla de bobinas para modificar son: ");
      console.log(this.tablaMaterialesBobinasCajonModificacion);
      console.log(this.tablaMaterialesCajonModificacion);
      console.log(this.listaBobinasCajon);
      this.loadingButton = false;
      respuesta.forEach((material) => {
        this.listaMaterialesOriginales.push({
          idMaterial: material.idMaterial,
          cantidad: material.cantidadSaldo,
        });
      });

      //console.log("Los materiales originales son: ");
      //console.log(this.listaMaterialesOriginales);

      //this.getDetallesCuadrilla();
      //this.getDetallesBobinas();
    },

    async getDetallesCuadrilla() {
      //this.url =
      //  this.$store.getters.urlBase + "Cajon/recuperarCajonCuadrilla";
      console.log("Ingreso en detalle de cuadrillas");
      this.url =
        this.$store.getters.urlBase +
        "Cajon/recuperarCajonCuadrilla?idCajon=" +
        this.idCajon;

      var listaCajon = [];
      this.cajones = listaCajon;

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar cuadrilla cajon");
          console.log(response.data);
          this.cuadrillaIntegrantes = response.data[0].cuadrilla;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async getMaterialesByIdCajon() {
      var respuesta;

      this.url = this.urlBase + "ot/recuperarrepuestosXOT";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      var obj = {
        idOT: this.$route.params.datos.otr_id,
      };

      respuesta = await axios
        .post(this.url, obj, config)
        .then((response) => response.data);

      this.tablaMaterialesCajonModificacion = respuesta;
      //const tablaMaterialesCajonModificacionConstante = respuesta;
      this.tablaMaterialesCajonModificacion.forEach((item) => {
        this.tablaMaterialesCajonModificacionCopia.push(item);
      });
    },

    vaciarEditedItem() {
      this.editedItem = {
        // cantidad: 0,
        // medida: "",
        // MaterialSeleccionado: null,
        // MaterialSeleccionadoNombre: null,
        // MaterialSeleccionadoId: null,
        // cantidadDisponible: 0,
        // cantidadIngresar: 0,
        // nombre: null,
        nombre: "",
        cantidadActualOT: null,
        cantidadDisponible: 0,
        cantidadIngresar: null,
      };
    },

    agregarMaterialALaLista() {
      console.log("Ingreso en agregar a la lista");
      if (this.editedIndex < -1) {
        Object.assign(
          this.listaMaterialesCajon[this.editedIndex],
          this.editedItem
        );
      } else {
        console.log("El ultimo registro es: ");
        console.log(
          this.listaMaterialesCajon[this.listaMaterialesCajon.length - 1]
        );
        if (this.listaMaterialesCajon.length == 0) {
          //console.log("El item a ingresar es: ");
          this.vaciarEditedItem();
          //console.log(this.editedItem);
          this.listaMaterialesCajon.push(this.editedItem);
        } else {
          console.log("El ultimo material de la lista es");
          console.log(
            this.listaMaterialesCajon[this.listaMaterialesCajon.length - 1]
              .idMaterial
          );
          if (
            this.listaMaterialesCajon[this.listaMaterialesCajon.length - 1]
              .idMaterial != null
          ) {
            //console.log("El item a ingresar es: ");
            this.vaciarEditedItem();
            //console.log(this.editedItem);
            this.listaMaterialesCajon.push(this.editedItem);
          }
          // this.vaciarEditedItem();
          // //console.log(this.editedItem);
          // this.listaMaterialesCajon.push(this.editedItem);
        }
      }
      console.log("Estoy hay en la tabla respuesto: ");
      console.log(this.listaMaterialesCajon);
    },

    getCantidadDisponible(secInicio, secFin) {
      return secFin - secInicio;
    },

    async confirmarOperacion(resultadoFinal) {
      console.log("El resultado final es:");
      console.log(resultadoFinal);
      var cantidadNegativa = 0;
      if (resultadoFinal == true) {
        var obj;

        if (this.tipoConsulta == 2) {
          let datosMaterial = [];

          console.log("Lo que hay en la tabla materiales es: ");
          console.log(this.tablaMaterialesCajonModificacion);

          this.tablaMaterialesCajonModificacion.forEach((material) => {
            if (material.cantidad < 0) {
              cantidadNegativa = 1;
            }
          });

          if (cantidadNegativa == 1) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "No puede ingresar una cantidades negativas",
              2,
              "red",
              "Confirmacion"
            );
            return;
          }

          this.tablaMaterialesCajonModificacion.forEach((material) => {
            console.log("El id del material es");
            console.log(material.idMaterial.idMaterial);
            console.log("La cantidad del material es:");
            console.log(material.cantidad);
            if (typeof material.idMaterial != "string") {
              datosMaterial.push({
                idMaterial: material.idMaterial.idMaterial.toString(),
                cantidad: parseFloat(material.cantidad),
              });
            } else {
              datosMaterial.push({
                idMaterial: material.idMaterial,
                cantidad: parseFloat(material.cantidad),
              });
            }
          });

          console.log("Los datos de datosMaterial es:");
          console.log(datosMaterial);

          // this.tablaMaterialesCajonModificacion.forEach((material) => {
          //   console.log("El id del material es");
          //   console.log(material.idMaterial.idMaterial);
          //   console.log("La cantidad del material es:");
          //   console.log(material.cantidad);
          //   if (typeof material.idMaterial != "string") {
          //     datosMaterial.push({
          //       idMaterial: material.idMaterial.idMaterial.toString(),
          //       cantidad: parseFloat(material.cantidad),
          //     });
          //   } else {
          //     datosMaterial.push({
          //       idMaterial: material.idMaterial,
          //       cantidad: parseFloat(material.cantidad),
          //     });
          //   }
          // });

          // for (let i = 0; i < datosMaterial.length; i++) {
          //   let material = datosMaterial[i];

          //   // Comprobar si el idMaterial existe en listaMaterialesOriginales
          //   let existe = this.listaMaterialesOriginales.some(
          //     (item) => item.idMaterial === material.idMaterial
          //   );
          //   console.log("En existe hay:");
          //   console.log(existe);
          //   // Si no existe, agregarlo a listaMaterialesEliminados
          //   if (!existe) {
          //     this.listaMaterialesEliminados.push(material);
          //   }
          // }

          // console.log("La lista de materiales eliminados es");
          // console.log(this.listaMaterialesEliminados);

          // let idMaterialSet = new Set();

          // // Filtrar la listaMaterialesEliminados para mantener solo los elementos únicos
          // this.listaMaterialesEliminados =
          //   this.listaMaterialesEliminados.filter((material) => {
          //     // Verificar si el idMaterial ya existe en el conjunto
          //     if (idMaterialSet.has(material.idMaterial)) {
          //       // Si el idMaterial ya existe, devolver false para eliminar este elemento de la lista
          //       return false;
          //     } else {
          //       // Si el idMaterial no existe, agregarlo al conjunto y devolver true para mantener este elemento en la lista
          //       idMaterialSet.add(material.idMaterial);
          //       return true;
          //     }
          //   });

          // console.log("La lista de materiales eliminados es");
          // console.log(this.listaMaterialesEliminados);

          let idMaterialSet2 = new Set();

          datosMaterial = datosMaterial.filter((material) => {
            // Verificar si el idMaterial ya existe en el conjunto
            if (idMaterialSet2.has(material.idMaterial)) {
              // Si el idMaterial ya existe, devolver false para eliminar este elemento de la lista
              return false;
            } else {
              // Si el idMaterial no existe, agregarlo al conjunto y devolver true para mantener este elemento en la lista
              idMaterialSet2.add(material.idMaterial);
              return true;
            }
          });

          console.log("Los materiales de la tabla son");
          console.log(datosMaterial);

          console.log("Los materiales eliminados son");
          console.log(this.listaMaterialesEliminados);

          this.url = this.$store.state.urlBase + "Cajon/modificarCajon";
          obj = {
            listaMateriales: datosMaterial,
            listaMaterialesEliminados: this.listaMaterialesEliminados,
            idCajon: this.idCajon,
          };
        }

        if (this.tipoConsulta == 3) {
          this.url = this.$store.state.urlBase + "Cajon/cerrarCajon";

          obj = {
            idCuadrilla: this.idCuadrilla,
            idCajon: this.idCajon,
            idUsuario: this.$store.getters.usuario.user_id,
          };

          console.log("Los datos de obj para cerrar el cajon son");
          console.log(obj);
        }

        const config = {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
          },
        };

        var respuesta = await axios
          .post(this.url, obj, config)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        // if (this.bandera == 1) {
        //   console.log("Ingresoe en la bandera 1 para ocultar el dialog");
        //   this.dialogForm = false;
        // }

        // this.$emit("recargarInspectores");
      }
    },

    // cambioMaterial(item) {
    //   // Aquí puedes realizar la lógica para obtener la cantidad disponible
    //   // Supongamos que tienes una función obtenerCantidadDisponible() que obtiene la cantidad disponible
    //   console.log("La cantidad de material dispnible es");
    //   console.log(item);
    //   item.cantidadDisponible = item.idMaterial.cantidad;
    //   //item.cantidad = obtenerCantidadDisponible(item.MaterialSeleccionadoNombre.idMaterial);
    // },

    async cambioMaterial(item) {
      var materialRepetido = 0;
      var mensaje;

      this.$set(item, "cargandoMedidores", true);
      // Aquí puedes realizar la lógica para obtener la cantidad disponible
      // Supongamos que tienes una función obtenerCantidadDisponible() que obtiene la cantidad disponible
      this.listaMaterialesCajon.forEach((material) => {
        //console.log(material.idMaterial);
        if (
          item.idMaterial.idMaterial == material.idMaterial ||
          item.idMaterial.idMaterial == material.idMaterial.idMaterial
        ) {
          materialRepetido = materialRepetido + 1;
          mensaje =
            "Ya existe en la lista un material con el codigo " +
            item.idMaterial.idMaterial;
          return;
        }
      });

      if (materialRepetido > 1) {
        this.listaMaterialesCajon.splice(
          this.listaMaterialesCajon.length - 1,
          1
        );
        this.$refs.dialogMensaje.abrirMensajeDialog(mensaje, 1, "red", "Aviso");
        return;
      }

      try {
        if (
          item.idMaterial.nombre.startsWith("Medidor") &&
          (item.idMaterial.nombre.toLowerCase().includes("tri") ||
            item.idMaterial.nombre.toLowerCase().includes("mono"))
        ) {
          console.log("Encontré un medidor");

          item.listaMedidores = [];
          await this.$nextTick();

          let medidores = await this.recuperarMedidoresXIdContratistaXMatricula(
            this.$store.getters.usuario.idContratista,
            item.idMaterial.idMaterial
          );

          // Transformar números en objetos
          item.listaMedidores = medidores.map((num) => ({
            idMedidor: num,
            nombre: num.toString(),
          }));

          this.$set(
            item,
            "listaMedidores",
            medidores.map((num) => ({
              idMedidor: num,
              nombre: num.toString(),
            }))
          );

          console.log("La nueva lista de medidores es:", item.listaMedidores);
          console.log("El medidor seleccionado es:", item);
          item.cantidadActualOT = item.idMaterial.cantidadActualOT;
        } else {
          item.cantidadActualOT = item.idMaterial.cantidadActualOT;
        }
      } catch (error) {
        console.error("Error al recuperar medidores:", error);
        this.$set(item, "listaMedidores", []);
      } finally {
        console.log("Ingreso en el finally");
        this.$set(item, "cargandoMedidores", false);
      }
    },

    async recuperarMedidoresXIdContratistaXMatricula(
      idContratista,
      idMaterial
    ) {
      var respuesta;

      this.url =
        `${this.$store.state.urlBase}Material/recuperarMedidoresXIdContratistaXMatricula` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&matricula=${idMaterial}`;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      //console.log("El resultado de la respuesta de recuperar medidores es:");

      this.listaMedidores = respuesta;

      //console.log(this.listaMedidores);

      // console.log(
      //   "Tipo de datos de this.listaMedidores:",
      //   typeof this.listaMedidores
      // );

      // if (Array.isArray(this.listaMedidores)) {
      //   console.log("this.listaMedidores es un array.");
      //   console.log("Longitud del array:", this.listaMedidores.length);
      // } else {
      //   console.log("this.listaMedidores no es un array.");
      //   console.log("Contenido de this.listaMedidores:", this.listaMedidores);
      // }
      return this.listaMedidores;
    },

    eliminarMaterialConfirmar(datos) {
      console.log("Lso datos del material eliminado es");
      console.log(datos);
      this.listaMaterialesCajon.splice(this.editedIndex, 1);
      this.listaMaterialesEliminados.push({
        idMaterial: this.idMaterialEliminado.toString(),
        cantidad: parseFloat(this.cantidadMaterialEliminado),
      });
      //this.listaMaterialesEliminados.push()
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },

    eliminarMaterial(item) {
      console.log("Los datos del material para eliminar son:");
      console.log(item);
      this.idMaterialEliminado = item.idMaterial;
      this.cantidadMaterialEliminado = item.cantidadSaldo;
      this.editedIndex = this.listaMaterialesCajon.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    editItem(item) {
      this.editedIndex = this.tablaMaterialesCajonModificacion.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async abrirModalCajones(datos) {
      this.idCajon = datos.idCajon;
      this.idCuadrilla = datos.idCuadrilla;
      console.log("El id del cajon es");
      console.log(this.idCajon);
      await this.getDetallesCajon();
      this.tipoConsulta = 1;
      this.colorDialogTitle = "blue";
      this.formTitle = "Detalles del Cajon";
      this.dialog = true;
    },

    async abrirModalModificarCajon(datos) {
      this.idCajon = datos.idCajon;
      this.tipoConsulta = 2;
      console.log(datos);

      console.log("El id del cajon es");
      console.log(this.idCajon);
      //this.getDetallesCuadrilla();
      await this.getDetallesCajon();

      this.colorDialogTitle = "green";
      this.formTitle = "Modificar Cajon";
      this.dialog = true;
    },

    openModal() {
      this.dialog = true;
    },

    close() {
      this.listaMaterialesEliminados = [];
      this.dialog = false;
    },
  },
};
</script>

<style></style>
